import { zodResolver } from '@hookform/resolvers/zod';
import { PartnerTransferSection } from 'further-types/lp/partner-transfer';
import { CalendarDay } from 'further-ui/utils';
import { partnerTransfers as rules } from 'further-ui/validations';
import { useForm } from 'react-hook-form';
import { z } from 'zod';
const formSchema = rules.CreatePartnerTransfer;

export type PartnerTransfersFormValues = z.infer<typeof formSchema>;

type UsePartnerTransfersFormProps = {
  defaultValues?: Partial<PartnerTransfersFormValues>;
};

export default function usePartnerTransfersForm({
  defaultValues: providedDefaultValues,
}: UsePartnerTransfersFormProps = {}) {
  const defaultValues: PartnerTransfersFormValues = {
    currentSection: PartnerTransferSection.PartnerTransfer,
    partnerTransferId: '',
    trasferrorCommitmentId: '',
    transferDate: new CalendarDay(new Date()),
    transferees: [
      {
        investorLabel: '',
        investorId: '',
        amountLcy: 0,
        percentage: 0,
      },
    ],
    ...providedDefaultValues,
  };

  const formMethods = useForm<PartnerTransfersFormValues>({
    shouldFocusError: true,
    resolver: zodResolver(formSchema),
    defaultValues,
    values: providedDefaultValues ? defaultValues : undefined,
    criteriaMode: 'all',
    resetOptions: {
      keepDefaultValues: false,
    },
  });

  return {
    formMethods,
  };
}
